import React from 'react';

function Menu(){
    return <nav className="navbar navbar-expand-lg navbar-dark">
  <div className="container">

  <a className="navbar-brand" href="#">
  </a>
  
  

 

  </div>
</nav>
}
  export default Menu;